import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
import {
  Navigation,
  Scrollbar,
  A11y,
  EffectFade,
  Autoplay,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/scrollbar";

const BannerOne = ({ id }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openVideo = () => {
    setIsOpen(true);
  };

  const closeVideo = () => {
    setIsOpen(false);
  };

  const handleKeyUp = (e) => {
    if (e.key === "Escape") {
      closeVideo();
    }
  };


    const containerStyle = {
    width: '100%',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: '#223971',
    padding: '10px 0',
    position: 'relative',
  };

  const textStyle = {
    display: 'inline-block',
    paddingLeft: '100%',
    animation: 'scroll 15s linear infinite',
    fontSize: '20px',
    color: '#FFFFFF',
    fontWeight: 'bold',
  };

  const keyframes = `
    @keyframes scroll {
      0% { transform: translateX(0); }
      100% { transform: translateX(-100%); }
    }
  `;


  return (
    <>
    <div className="tmp-banner-swiper-one-area" id={id}>
      <Swiper
        // install Swiper modules
        modules={[Navigation, EffectFade, Scrollbar, A11y, Autoplay]}
        className="mySwiper-banner-one"
        speed={500}
        slidesPerView={1}
        spaceBetween={0}
        // autoplay={{
        //     delay: 5000,
        //     disableOnInteraction: false,
        // }}
        loop={true}
        effect="fade"
        navigation={{
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }}
        breakpoints={{
          1200: { slidesPerView: 1 },
          900: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          580: { slidesPerView: 1 },
          450: { slidesPerView: 1 },
          0: { slidesPerView: 1 },
        }}
      >
        <SwiperSlide>
          <div className="tmp-banner-area bg_image-1 bg_image banner-one-height-control tmp-section-gap">
            <div className="shape-image-banner-one">
              {/* <img
                        src="assets/images/banner/shape/01.png"
                        alt="banner"
                        className="one"
                    />
                    <img
                        src="assets/images/banner/shape/02.png"
                        alt="banner"
                        className="two"
                    /> */}
              <img
                src="assets/images/banner/shape/v2v about us banner.png"
                alt="banner"
                className="three"
              />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-xl-6">
                  <div className="banner-one-main-wrapper">
                    <div className="inner">
                        <h1 className="title MainSliderTaxt " style={{fontSize:'40px'}}>
                        V2V BN Federation 
                        {/* For the Vaishnavs,<br /> By the Vaishnavs, <br />With the Vaishnavs */}
                      </h1>
                      <span className="sub-title SubSliderTaxt" style={{
                    fontSize:"20px"
                      }}>
                        Fostering Meaningful Connections
                      </span>
                      <h1 className="title MainSliderTaxt " style={{fontSize:'30px',lineHeight:'50px'}}>
                         For the Vaishnavs, By the Vaishnavs, <br/>With the Vaishnavs
                        {/* For the Vaishnavs,<br /> By the Vaishnavs, <br />With the Vaishnavs */}
                      </h1>
                      {/* <p className="disc">
                            Discover a vibrant community of professionals from diverse industries. At V2V, we empower collaboration, drive knowledge exchange, and unlock business growth. Build partnerships, gain insights, and take your career to the next level with us
                            </p> */}
                      <div className="button-area-banner-one">
                        <Link to={"About"} className="tmp-btn btn-primary">
                          Get Started Now
                        </Link>
                        {/* video icon */}
                        {/* <div
                          className="vedio-icone"
                          data-tmp-cursor="lg"
                          data-tmp-cursor-text="Play Video"
                        >
                          <Link
                            className="video-play-button play-video"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              openVideo();
                            }}
                          >
                            <span />
                            <p className="text MainSliderTaxt">Play Video</p>
                          </Link>

                          {isOpen && (
                            <div
                              className="video-overlay open"
                              onClick={closeVideo}
                            >
                              <iframe
                                width={560}
                                height={315}
                                src="https://www.youtube.com/embed/zqKsH9OXKKA?si=kzsYrJrHnfcoR43L"
                                title="YouTube video player"
                                
                                allowfullscreen
                              ></iframe>
                              <Link
                                className="video-overlay-close"
                                onClick={(e) => {
                                  e.preventDefault();
                                  closeVideo();
                                }}
                              >
                                ×
                              </Link>
                            </div>
                          )}

                          {/* Listen for the Escape key to close the video 
                          {isOpen && (
                            <div onKeyUp={handleKeyUp} tabIndex="0"></div>
                          )}
                        </div> */}
                        {/* video icon */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="tmp-banner-area bg_image-2 bg_image banner-one-height-control tmp-section-gap">
            <div className="shape-image-banner-one">
              <img
                src="assets/images/banner/shape/v2v about us banner.png"
                alt="banner"
                className="three"
              />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-xl-6">
                  <div className="banner-one-main-wrapper">
                    <div className="inner">
                      <span className="sub-title SubSliderTaxt" style={{
                        fontSize:"20px"
                      }}>
                        Empowering Growth Through Knowledge
                      </span>
                      <h1 className="title MainSliderTaxt">
                        Access Exclusive Business Resources
                      </h1>
                      {/* <p className="disc">
                                We help small startups grow from idea to millions of
                                users. we can also <br />
                                automate your marketing and customer service.
                            </p> */}
                      <div className="button-area-banner-one">
                        <Link to={"About"} className="tmp-btn btn-primary">
                          Get Started Now
                        </Link>
                        {/* video icon */}
                        {/* <div
                          className="vedio-icone"
                          data-tmp-cursor="lg"
                          data-tmp-cursor-text="Play Video"
                        >
                          <Link
                            className="video-play-button play-video"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              openVideo();
                            }}
                          >
                            <span />
                            <p className="text MainSliderTaxt">Play Video</p>
                          </Link>

                          {isOpen && (
                            <div
                              className="video-overlay open"
                              onClick={closeVideo}
                            >
                                 <iframe
                                width={560}
                                height={315}
                                src="https://www.youtube.com/embed/zqKsH9OXKKA?si=kzsYrJrHnfcoR43L"
                                title="YouTube video player"
                                
                                allowfullscreen
                              ></iframe>
                              <Link
                                className="video-overlay-close"
                                onClick={(e) => {
                                  e.preventDefault();
                                  closeVideo();
                                }}
                              >
                                ×
                              </Link>
                            </div>
                          )}

                         
                          {isOpen && (
                            <div onKeyUp={handleKeyUp} tabIndex="0"></div>
                          )}
                        </div> */}
                        {/* video icon */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="tmp-banner-area bg_image-3 bg_image banner-one-height-control tmp-section-gap">
            <div className="shape-image-banner-one">
              <img
                src="assets/images/banner/shape/v2v about us banner.png"
                alt="banner"
                className="three"
              />
            </div>
            <div className="container">
              <div className="row">
                <div className="col-xl-6">
                  <div className="banner-one-main-wrapper">
                    <div className="inner">
                      <span className="sub-title SubSliderTaxt" style={{fontSize:'20px'}}>
                        Connect, Learn, and Collaborate
                      </span>
                      <h1 className="title MainSliderTaxt">
                        Powering Business Growth
                      </h1>
                      {/* <p className="disc">
                                We help small startups grow from idea to millions of
                                users. we can also <br />
                                automate your marketing and customer service.
                            </p> */}
                      <div className="button-area-banner-one">
                        <Link to={"About"} className="tmp-btn btn-primary">
                          Get Started Now
                        </Link>
                        {/* video icon */}
                        {/* <div
                          className="vedio-icone"
                          data-tmp-cursor="lg"
                          data-tmp-cursor-text="Play Video"
                        >
                          <Link
                            className="video-play-button play-video"
                            href="#"
                            onClick={(e) => {
                              e.preventDefault();
                              openVideo();
                            }}
                          >
                            <span />
                            <p className="text MainSliderTaxt">Play Video</p>
                          </Link>

                          {isOpen && (
                            <div
                              className="video-overlay open"
                              onClick={closeVideo}
                            >
                               <iframe
                                width={560}
                                height={315}
                                src="https://www.youtube.com/embed/zqKsH9OXKKA?si=kzsYrJrHnfcoR43L"
                                title="YouTube video player"
                                
                                allowfullscreen
                              ></iframe>
                              <Link
                                className="video-overlay-close"
                                onClick={(e) => {
                                  e.preventDefault();
                                  closeVideo();
                                }}
                              >
                                ×
                              </Link>
                            </div>
                          )}

                        
                          {isOpen && (
                            <div onKeyUp={handleKeyUp} tabIndex="0"></div>
                          )}
                        </div> */}
                        {/* video icon */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <div className="swiper-button-next"></div>
        <div className="swiper-button-prev"></div>
      </Swiper>
    </div>


    <div>
      <style>{keyframes}</style>
      <div style={containerStyle}>
        <div style={textStyle}>
          V2VBN | Vaishnav to Vaishnav Business Network | For the Vaishnavs | By the Vaishnavs | With the Vaishnavs
        </div>
      </div>
    </div>
    </>
  );
};

export default BannerOne;
